/**
 * @class meleCarousel
 * @description
 *
 * # Purpose
 * Implements `<mele-carousel>` custom web element.
 *
 * # Use
 * Create element in HTML:
 * ```
 * parentEl.innerHTML += '<mele-carousel></mele-carousel>';
 * ```
 * Create element in JavaScript:
 * ```
 * parentEl.appendChildren({
 *   tag: 'mele-carousel',
 *   ... other attributes ...
 * })
 * ```
 *
 * # Implementation notes
 *
 */

import meleContainer from 'meleContainer';

const PROPERTIES = _.extend({}, {
	selected:   {type: "integer", description: "currently selected item"},
}, meleContainer._properties);

export default class meleCarousel extends meleContainer {

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Creates internal DOM structure.
*/
init() {
  this._body = this.appendChildren({tag: 'mele-body'});

  let timer = null;
  //Scrolling event start
  this._body.addEventListener('scroll', (e)=>{
    clearTimeout(timer);
    //Renew timer
    timer = setTimeout(()=>{
      const displayedItems = this.getVisibleItems()
      const count = displayedItems.length
      Math.floor(e.target.scrollWidth / count)
      let idx = e.target.scrollLeft == 0 ? 0 : Math.round(e.target.scrollLeft / e.target.offsetWidth)
      this.updateIndicator(idx)
    }, 100);
  }, false);
  this._indicators = this.appendChildren({tag: "div", class: "indicators"})
} // init

getVisibleItems(){
  return this._body.findAll('>*:not([hidden])')
}

itemsChanged() {
  if(this.items.length == 0) return
  let indicators = []

  const displayedItems = this.getVisibleItems()
  for(let el of displayedItems){
    const key = el.getAttribute("key")
    el.id = "slide-"+key
    indicators.push({
      tag: "a",
      class: "indicator",
      href: "#slide-"+ key,
      key: key,
      onclick: (e) => this.updateIndicator(e.target.getAttribute('key'))
    })
  }
  this._indicators.appendChildren(indicators)
  this.updateIndicator(0)
} // itemsChanged

updateIndicator(idx) {
  this.selected = idx
  const displayedItems = this.getVisibleItems()
  const key = displayedItems[idx]?.getAttribute("key")
  this._indicators.forAll("a", el=>{
    if(key==el.getAttribute('key')){
      el.setAttribute('selected', '')
    }else {
      el.removeAttribute('selected')
    }
  })
} // updateIndicator

selectedChanged(value) {
  const displayedItems = this.getVisibleItems()
  const key = displayedItems[value]?.getAttribute("key")
  const hash = "#slide-"+key
  if(window.location.hash !== hash) window.location.hash = hash
}

} // class meleCarousel

meleCarousel._properties = PROPERTIES;
meleCarousel.observedAttributes = _.keys(PROPERTIES);

window.customElements.define('mele-carousel', meleCarousel);
